import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'Mensagens de E-mail',
  labels: {
    view_full_message: 'Ver mensagem completa',
    status: 'Estado:',
    on: 'Ativo',
    off: 'Inativo',
  },
  tiles: {
    sends_count: 'Mensagens Enviadas',
    delivery_rate: 'Taxa de Entrega',
    delivered_suffix: 'entregues',
    open_rate: 'Taxa de Abertura',
    opened_suffix: 'abertas',
    click_rate: 'Taxa de Cliques',
    clicked_suffix: 'clicadas',
    spam_report_rate: 'Taxa de Spam',
    spam_reports_suffix: 'denúncias',
    unsubscribe_rate: 'Taxa de Cancelamento',
    unsubscribes_suffix: 'cancelamentos',
  },
  toasts: {
    failed_to_update_status: 'Erro ao atualizar estado',
    failed_to_load_data: 'Erro ao carregar dados',
  },

  preview_modal: {
    title: 'Pré-visualização do Modelo',
    labels: {
      subject: 'Assunto:',
      close: 'Fechar',
    },
    toasts: {
      failed_to_load_data: 'Erro ao carregar dados de pré-visualização',
    },
    template_data: {
      recipient_name: '&lt;Primeiro nome&gt;',
    },
  },
};
